// extracted by mini-css-extract-plugin
export default {"company-data":"CompanyDrawer_company-data__LULZV","data":"CompanyDrawer_data__OFYDF"};